import React from 'react'
import Link from './Link'
import Image from './Image'

const Figure = ({
  image,
  image_link,
  align_image,
  image_size,
  caption,
  parallax = true,
  forceLoad,
}) => {
  return (
    <>
      {parallax === true ? (
        <figure
          className={`${align_image} ${image_size}`}
          data-rellax-center={true}
          data-rellax-speed={2}
        >
          <div className="figmedia">
            <Link link={image_link}>
              <Image image={image} forceLoad={forceLoad} />
            </Link>
          </div>
          {caption && <figcaption>{caption}</figcaption>}
        </figure>
      ) : (
        <figure className={`${align_image} ${image_size}`}>
          <div className="figmedia">
            <Link link={image_link}>
              <Image image={image} forceLoad={forceLoad} />
            </Link>
          </div>
          {caption && <figcaption>{caption}</figcaption>}
        </figure>
      )}
    </>
  )
}

export default Figure
